import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FileUploadModule } from 'primeng/fileupload';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { HisFileUploadComponent } from './component/his-file-upload.component';

import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';
import { HisFileUploadPlamComponent } from './component/his-file-upload-plam.component';
import { HisUploadFileDownloadComponent } from './component/doc-download/his-upload-file-download.component';
import { HisUploadFileImageComponent } from './component/upload-file-image/his-upload-file-image.component';
import { HisUploadListComponent } from './component/upload-list/his-upload-list.component';
import { HisSelectFileComponent } from './component/selectFile/component/his-select-file.component';
import { HisSelectFileItemComponent } from './component/selectFile/component/item/his-select-file-item.component';
import { HisSelectFileLocalMediaComponent } from './component/selectFile/component/localMedia/his-select-file-local-media.component';
import { HisSelectFileMetadataComponent } from './component/selectFile/component/metadata/his-select-file-metadata.component';
import { HisSelectFileMetadataIconComponent } from './component/selectFile/component/metadata/his-select-file-metadata-icon.component';
import { HisConfpackageIconComponent } from './component/selectFile/component/metadata/confpackage/his-confpackage-icon.component';
import { HisSignedPdfResourceIconComponent } from './component/selectFile/component/metadata/signedPdf/his-signed-pdf-resource-icon.component';
import { HisSelectFilePropertyDisplayDirective, HisSelectFilePropertyDisplayIconDirective } from './component/selectFile/directive/his-select-file-property-template.directive';
import { ProgressBarModule } from 'primeng/progressbar';
import { Accordion, AccordionPanel, AccordionHeader, AccordionContent } from 'primeng/accordion';
import { HisDataSourceIconComponent } from './component/selectFile/component/metadata/dataSource/his-data-source-icon.component';

/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        // primeng
        TableModule,
        DataViewModule,
        DialogModule,
        AutoCompleteModule,
        FileUploadModule,
        DragDropModule,
        OverlayPanelModule,
        ProgressBarModule,
        // HIS
        HisCoreSharedModule,
        HisStructureSharedModule,
        Accordion,
        AccordionPanel,
        AccordionHeader,
        AccordionContent
    ],

    declarations: [
        HisFileUploadComponent,
        HisFileUploadPlamComponent,
        HisUploadFileDownloadComponent,
        HisUploadFileImageComponent,
        HisUploadListComponent,
        HisSelectFileComponent,
        HisSelectFileItemComponent,
        HisSelectFileLocalMediaComponent,
        HisSelectFileMetadataComponent,
        HisSelectFileMetadataIconComponent,
        HisConfpackageIconComponent,
        HisDataSourceIconComponent,
        HisSignedPdfResourceIconComponent,
        HisSelectFilePropertyDisplayIconDirective,
        HisSelectFilePropertyDisplayDirective,
    ],

    exports: [
        HisFileUploadComponent,
        HisFileUploadPlamComponent,
        HisUploadFileDownloadComponent,
        HisUploadFileImageComponent,
        HisUploadListComponent,
        HisSelectFileComponent,
        HisSelectFilePropertyDisplayIconDirective,
        HisSelectFilePropertyDisplayDirective,
    ]
    // NO PROVIDERS! Providers need to go into HisInputCoreModule
} )
export class HisFileUploadSharedModule {

}
